import { render } from "./IconChevronLeft.vue?vue&type=template&id=28dc47b4"
import script from "./IconChevronLeft.vue?vue&type=script&lang=js"
export * from "./IconChevronLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconChevronLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28dc47b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28dc47b4', __exports__)) {
    api.reload('28dc47b4', __exports__)
  }
  
  module.hot.accept("./IconChevronLeft.vue?vue&type=template&id=28dc47b4", () => {
    api.rerender('28dc47b4', render)
  })

}


export default __exports__